import { render, staticRenderFns } from "./seriesResultItem.vue?vue&type=template&id=72b76632&"
import script from "./seriesResultItem.vue?vue&type=script&lang=js&"
export * from "./seriesResultItem.vue?vue&type=script&lang=js&"
import style0 from "./seriesResultItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "seriesResultItem.vue"
export default component.exports